import { getCraftData } from '../craft'
import { request } from '../craft/graphql'
import { getStoryTags } from './storyTags'
import S3_IMAGE_FRAGMENT from './fragments/s3Image'

const FILTERED_STORIES_QUERY = `
query FilteredStories($relatedIds: [QueryArgument], $limit: Int, $offset: Int) {
  entry(
    section: "storiesAndInvestigations"
  ) {
    ...on storiesAndInvestigations_storiesAndInvestigations_Entry {
      title
      introCopy
    }
  }

  stories: entries(
    section: "stories"
    relatedToAll: $relatedIds
    orderBy: "postDate desc"
    limit: $limit,
    offset: $offset
  ) {
    ...on stories_story_Entry {
      id
      slug
      title
      postDate
      location {
        id
        slug
        title
      }
      topic {
        id
        slug
        title
      }
      entryAuthor {
        id
        slug
        title
      }
      mainImage {
        ${ S3_IMAGE_FRAGMENT }
      }
    }
  }

  storiesCount: entryCount(
    section: "stories"
    relatedToAll: $relatedIds
  )
}
`

const queryPagination = page => {
  if ( page === 1 ) {
    return {
      limit: 9,
      offset: 0,
    }
  }

  return {
    limit: 15,
    offset: 9 + ( 15 * ( page - 2 ) ),
  }
}

export const pageCount = entryCount => Math.ceil( ( entryCount - 9 ) / 15 ) + 1

export const getServerSideProps = async ctx => {
  const { query } = ctx
  
  const GET_IDS_FROM_SLUG = `
    query(
      $slug: [String],
      $authorSlug: [String]
    ) {
      tags(
        slug: $slug,
      ) {
        id
      }
      authors: entries(
        section: "authors"
        slug: $authorSlug,
      ) {
        canonicalId
      }
    }
  `

  const slugs = []

  if ( query.location ) {
    slugs.push( query.location )
  }
  
  if ( query.topic ) {
    slugs.push( query.topic )
  }

  let relatedIds = null

  if ( slugs.length || query.author ) {
    const { data } = await request(
      GET_IDS_FROM_SLUG,
      {
        slug: slugs.length ? slugs : [null],
        authorSlug: [query.author],
      },
    )

    relatedIds = [
      ...data.tags.map( t => t.id ),
      ...data.authors.map( t => t.canonicalId ),
    ]
  }
  
  const [craftResult, storyTags] = await Promise.all( [
    getCraftData( FILTERED_STORIES_QUERY, ['relatedIds', 'limit', 'offset'] )( {
      ...ctx,
      params: {
        relatedIds,
        ...queryPagination( parseInt( query.page, 10 ) || 1 ),
      },
    } ),
    getStoryTags(),
  ] )

  return {
    ...craftResult,
    props: {
      ...craftResult.props,
      storyTags,
    },
  }
}
